<div class="relative h-full grid grid-rows-[auto_max-content] overflow-hidden">
  <div class="overflow-hidden">
    @if (enhancedItems().length > 1) {
      <button
        class="absolute bg-opacity-25 rounded-full top-[50%] translate-y-[-50%] left-4 p-2 flex flex-col items-center justify-center bg-white z-30"
        (click)="prev()"
      >
        <ng-icon name="heroChevronLeft" size="20px"></ng-icon><span class="sr-only">Vorheriges Bild</span>
      </button>
      <button
        class="absolute bg-opacity-25 rounded-full top-[50%] translate-y-[-50%] right-4 p-2 flex flex-col items-center justify-center bg-white z-30"
        (click)="next()"
      >
        <ng-icon name="heroChevronRight" size="20px"></ng-icon><span class="sr-only">Nächstes Bild</span>
      </button>
    }

    <swiper-container
      class="h-full w-full"
      #swiperRef
      slides-per-view="1"
      space-between="50"
      loop="true"
      [initial-slide]="currentIndex() + ''"
    >
      @for (item of enhancedItems(); track item.url; let i = $index) {
        <swiper-slide>
          @if (isInitialized()) {
            @switch (item.type) {
              @case (BbitImageOverlayItemType.VIDEO) {
                <div class="w-full h-full flex items-center justify-center p-16">
                  <iframe
                    [src]="item.sanitizedUrl"
                    [title]="getAltText(i)"
                    frameborder="0"
                    class="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              }
              @default {
                <picture
                  (click)="show(i)"
                  [bbitPictureSrc]="item.url"
                  [bbitPictureDefaultSize]="imageSize()"
                  [bbitPictureImgClasses]="
                    'w-full object-scale-down ' + (fullScreen() ? 'h-full ' : 'h-96 ') + (enableOverlay() ? 'cursor-zoom-in ' : '')
                  "
                  [bbitPictureAlt]="getAltText(i)"
                ></picture>

                @if (fullScreen() && !hideOriginalImage()) {
                  <a
                    class="absolute right-8 bottom-8 bg-white bg-opacity-50 text-xs text-gray-500 hover:text-black"
                    [href]="item.url"
                    target="_blank"
                    >{{ { key: 'showOriginalImage' } | i18n }}</a
                  >
                }
              }
            }
          }
        </swiper-slide>
      }
    </swiper-container>
  </div>

  @if (!fullScreen() && enhancedItems().length > 1) {
    <div class="grid grid-cols-4 gap-4 p-4">
      @for (item of enhancedItems(); track item.url; let i = $index) {
        <div class="relative">
          @switch (item.type) {
            @case (BbitImageOverlayItemType.VIDEO) {
              <picture (click)="swipeTo(i)">
                <img [src]="item.thumbnail" [alt]="getAltText(i)" class="object-scale-down h-16 w-full cursor-pointer" />
              </picture>
              <ng-icon
                name="heroPlaySolid"
                class="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] text-white pointer-events-none"
                size="24px"
              ></ng-icon>
            }
            @default {
              <picture
                [bbitPictureSrc]="item.thumbnail"
                [bbitPictureDefaultSize]="previewImageSize()"
                [bbitPictureImgClasses]="'object-scale-down h-16 w-full cursor-pointer'"
                [bbitPictureAlt]="getAltText(i)"
                (click)="swipeTo(i)"
              ></picture>
            }
          }
        </div>
      }
    </div>
  }
</div>
